import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { claimCheckout } from '../../services/billingApi';

export default function SubscriptionSuccess() {
  const navigate = useNavigate();
  const [claimState, setClaimState] = useState('idle');

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get('session_id');
    if (!sessionId) return;

    // Landing-page checkouts have no workspace yet - attach the purchase to the signed-in workspace.
    setClaimState('pending');
    claimCheckout({ sessionId })
      .then(() => setClaimState('done'))
      .catch(() => setClaimState('error'))
      .finally(() => {
        window.history.replaceState({}, document.title, '/subscription-success');
      });
  }, []);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="w-full max-w-xl rounded-2xl border border-neutral-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
          <svg className="h-6 w-6 text-green-700" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M20 7L10 17L4 11" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h1 className="text-2xl font-semibold text-gray-900">Twoja subskrypcja jest aktywna</h1>
        <p className="mt-2 text-sm text-gray-600">
          Platnosc zakonczona sukcesem. Mozesz wrocic do aplikacji i korzystac z pelnych mozliwosci.
        </p>
        {claimState === 'pending' && (
          <p className="mt-3 text-sm text-gray-500">Przypisujemy subskrypcje do Twojego konta...</p>
        )}
        {claimState === 'error' && (
          <p className="mt-3 text-sm text-amber-700">
            Nie udalo sie automatycznie przypisac subskrypcji do tego konta. Jesli plan nie pojawi sie w profilu w ciagu kilku minut, skontaktuj sie z nami.
          </p>
        )}
        <button
          onClick={() => navigate('/dashboard')}
          disabled={claimState === 'pending'}
          className="mt-6 inline-flex items-center justify-center rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-primary-500 disabled:opacity-60"
        >
          Przejdz do homepage
        </button>
      </div>
    </div>
  );
}
